import { IBreadcrumb } from 'shared/types/breadcrumbs';
import { IApplicationState } from 'shared/types/redux';

export const getBreabcrumbs = (state: IApplicationState): IBreadcrumb[] => state.breadcrumbs;
